// Module
var code = "<form-editor *ngIf=\"advancedSearchConfiguration\" #advancedSearchEditor [configuration]=\"advancedSearchConfiguration\" [fieldsPerRow]=\"1\" (selectionClosedAction)=\"emitSearch()\" (valueChangedAction)=\"emitSearch()\"> </form-editor>";
// Exports
module.exports = code;